var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJfLogoNoText = function SvgJfLogoNoText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.287.982A7.53 7.53 0 0 0 1.024 3.817a1.734 1.734 0 0 0 .628 2.36s.452.335 1.138.82L1.513 9.22a.9.9 0 0 0 .326 1.226l.151.088a.89.89 0 0 0 1.22-.329l1.204-2.093c.418.277.852.56 1.283.83l-3.23 5.623a.9.9 0 0 0 .327 1.226l.151.088a.89.89 0 0 0 1.22-.329l3.23-5.622c.447.24.909.48 1.356.704l-2.135 3.72a.9.9 0 0 0 .326 1.226l.151.087a.89.89 0 0 0 1.22-.328l2.21-3.85c.761.353 1.275.578 1.275.578a1.715 1.715 0 0 0 2.348-.631l.058-.099c2.11-3.673.774-8.277-2.917-10.354"
  })));
};
export default SvgJfLogoNoText;